import React from "react";
import MainLayout from "../../components/Layouts";
import ShopBusinessContract from "../../components/Shop/ContractAddress/index";

const ShopDetailsPage = () => {
  return (
    <MainLayout>
      <ShopBusinessContract /> 
    </MainLayout>
  );
};

export default ShopDetailsPage;
